import { useLang } from '@/i18n';
import EfIcon from '@elem/ui/ef-icon';
import EfImg from '@elem/ui/ef-img';
import EfSection from '@elem/ui/ef-section';
import EfSpec from '@elem/ui/ef-spec';
import EfTab, { EfTabItemProps } from '@elem/ui/ef-tab';
import { useEffect, useState } from 'react';
import imgLocale1 from './imgs/imgLocale1';
import imgLocale2 from './imgs/imgLocale2';
import imgLocale3 from './imgs/imgLocale3';
import styles from './index.module.scss';

const locale = 'mx';
const G_TAB_CHANGE_EVENT = 'delta3-g-tab-change';

export default function TheComp() {
    const { t } = useLang('delta3series');

    const img1 = imgLocale1[locale] || imgLocale1.us;
    const img2 = imgLocale2[locale] || imgLocale2.us;
    const img3 = imgLocale3[locale] || imgLocale3.us;

    const listTabH: EfTabItemProps[] = [
        { type: 'a1', title: t('G_item1_tab') },
        { type: 'a2', title: t('G_item2_tab') },
        { type: 'a3', title: t('G_item3_tab') },
    ];

    const tabObj: any = {
        a1: {
            pc: img1.pc,
            h5: img1.h5,
            title: t.rich('G_item1_title', {
                sup: (tx: string) => <sup className="sup">{tx}</sup>,
            }),
            desc: t.rich('G_item1_desc', {
                sup: (tx: string) => <sup className="sup">{tx}</sup>,
            }),
        },
        a2: {
            pc: img2.pc,
            h5: img2.h5,
            title: t.rich('G_item2_title', {
                sup: (tx: string) => <sup className="sup">{tx}</sup>,
            }),
            desc: t.rich('G_item2_desc', {
                sup: (tx: string) => <sup className="sup">{tx}</sup>,
            }),
        },
        a3: {
            pc: img3.pc,
            h5: img3.h5,
            title: (
                <EfIcon
                    className="title-icon-a"
                    pc="https://websiteoss.ecoflow.com/upload/image/1776138124132/X-guard.png"
                />
            ),
            desc: t.rich('G_item3_desc', {
                sup: (tx: string) => <sup className="sup">{tx}</sup>,
            }),
            footer: t('G_item3_footer')
        },
    };

    const [activeType, setActiveType] = useState('a1');
    const [activeItem, setActiveItem] = useState(tabObj.a1);

    const updateActiveTab = (type: string) => {
        setActiveType(type);
        setActiveItem(tabObj[type] || tabObj.a1);
    };

    const activeTypeCallback = (item: EfTabItemProps) => {
        updateActiveTab(item.type);
    };

    useEffect(() => {
        const handleTabChange = (event: Event) => {
            const { detail } = event as CustomEvent<{ tabType?: string }>;
            updateActiveTab(detail?.tabType || 'a1');
        };

        window.addEventListener(G_TAB_CHANGE_EVENT, handleTabChange);

        return () => {
            window.removeEventListener(G_TAB_CHANGE_EVENT, handleTabChange);
        };
    }, []);

    return (
        <div className={`${styles.TheComp} GtmModuleData-section range6`} data-section-id="D3-G" id='D3-G'>
            <EfSection hasAnimation={false} theme="black" label={t('G_label')} title={t('G_title')} />
            <div className={`box white`}>
                <div className="box-img">
                    <EfImg pc={activeItem.pc} h5={activeItem?.h5 || activeItem.pc} />
                </div>
                <div className="box-msg">
                    <div className="box-title">{activeItem.title}</div>
                    <div className="box-desc">{activeItem.desc}</div>
                    <div className="footer">{activeItem.footer}</div>
                </div>
            </div>
            <EfTab theme="white" list_name={t('G_title')} items={listTabH} activeType={activeType} onChange={activeTypeCallback} />
        </div>
    );
}
